<template>
  <div>
    <div v-if="showVideo" class="charity-video">
      <video id="charity-video" width="820" height="600" controls>
        <source :src="charityVideoURL" type="video/mp4" />
      </video>
    </div>
    <div v-if="enteredRoom && !showVideo">
      <session-room
        :session="selectedSession"
        :local-stream="localStream"
        :remote-stream="remoteStream"
        :profile="profile"
        :room-id="roomId"
        :signaling-state="signalingState"
        :connection-state="peerConnectionState"
        :ice-connection-state="iceConnectionState"
        :ice-gathering-state="iceGatheringState"
        :data-channel="dataChannel"
        :mute-mic="muteMic"
        :mute-camera="muteCamera"
        :otherUserMicMuted="otherUserMicMuted"
        :otherUserCameraMuted="otherUserCameraMuted"
        :otherUserTime="otherUserTime"
        :sharingScreen="sharingScreen"
        :displayStream="displayStream"
        :refresh="refresh"
        :chats="chats"
        :caller="caller"
        :callee="callee"
        :micLabel="micLabel"
        :cameraLabel="cameraLabel"
        @hang-up="handleHangUp"
        @rejoin-session="rejoinSession"
        @back-to-lounge="backToLounge"
        @toggle-audio="toggleAudio"
        @toggle-video="toggleVideo"
        @share-screen="shareScreen"
        @send-message="sendMessage"
        @change-audio-input="changeAudioInput"
        @change-audio-output="changeAudioOutput"
        @change-video-input="changeVideoInput"
      />
    </div>
    <div
      v-if="!enteredRoom && !fetching && !showVideo && !showFeedbackPage"
      class="home"
    >
      <session-navbar
        :name="profile ? profile.firstname : null"
        :countDown="null"
        :localtime="null"
      />

      <div style="height: 100px"></div>
      <div v-if="setting" @click="setting = false" class="overlay"></div>

      <div class="container">
        <div class="row mt-5">
          <div
            class="col-lg-6 d-flex justify-content-center align-items-center"
          >
            <div class="left-pane">
              <div class="display-pane">
                <video
                  id="localVideo"
                  class="local-video"
                  muted
                  autoplay
                  playsinline
                  v-observe-visibility="visibiltyCheck"
                ></video>
                <transition name="fade">
                  <session-settings
                    :key="refreshUserMedia"
                    class="settings"
                    :micLabel="micLabel"
                    :cameraLabel="cameraLabel"
                    @change-audio-input="changeAudioInput"
                    @change-audio-output="changeAudioOutput"
                    @change-video-input="changeVideoInput"
                    v-if="setting"
                  />
                </transition>
                <div class="display-actions">
                  <div class="signals">
                    <svg
                      v-show="muteMic"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.3999 5.3C16.3999 4.58203 16.9819 4 17.6999 4C18.4179 4 18.9999 4.58203 18.9999 5.3V18.3C18.9999 19.018 18.4179 19.6 17.6999 19.6C16.9819 19.6 16.3999 19.018 16.3999 18.3V5.3Z"
                        fill="none"
                      />
                      <path
                        d="M6 14.4C6 13.682 6.58203 13.1 7.3 13.1C8.01797 13.1 8.6 13.682 8.6 14.4V18.3C8.6 19.018 8.01797 19.6 7.3 19.6C6.58203 19.6 6 19.018 6 18.3V14.4Z"
                        fill="none"
                      />
                      <path
                        d="M11.2002 9.20001C11.2002 8.48204 11.7822 7.90001 12.5002 7.90001C13.2182 7.90001 13.8002 8.48204 13.8002 9.20001V18.3C13.8002 19.018 13.2182 19.6 12.5002 19.6C11.7822 19.6 11.2002 19.018 11.2002 18.3V9.20001Z"
                        fill="none"
                      />
                    </svg>
                    <svg
                      v-show="!muteMic"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        id="level3"
                        d="M16.3999 5.3C16.3999 4.58203 16.9819 4 17.6999 4C18.4179 4 18.9999 4.58203 18.9999 5.3V18.3C18.9999 19.018 18.4179 19.6 17.6999 19.6C16.9819 19.6 16.3999 19.018 16.3999 18.3V5.3Z"
                        fill="none"
                      />
                      <path
                        id="level1"
                        d="M6 14.4C6 13.682 6.58203 13.1 7.3 13.1C8.01797 13.1 8.6 13.682 8.6 14.4V18.3C8.6 19.018 8.01797 19.6 7.3 19.6C6.58203 19.6 6 19.018 6 18.3V14.4Z"
                        fill="none"
                      />
                      <path
                        id="level2"
                        d="M11.2002 9.20001C11.2002 8.48204 11.7822 7.90001 12.5002 7.90001C13.2182 7.90001 13.8002 8.48204 13.8002 9.20001V18.3C13.8002 19.018 13.2182 19.6 12.5002 19.6C11.7822 19.6 11.2002 19.018 11.2002 18.3V9.20001Z"
                        fill="none"
                      />
                    </svg>
                  </div>
                  <div class="action-btn">
                    <button
                      :class="{ active: !muteCamera }"
                      @click="toggleVideo"
                    >
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M3.28578 5.85714C3.05846 5.85714 2.84044 5.94744 2.67969 6.10819C2.51895 6.26894 2.42864 6.48695 2.42864 6.71428V15.2857C2.42864 15.513 2.51895 15.7311 2.67969 15.8918C2.84044 16.0525 3.05846 16.1429 3.28578 16.1429H12.7144C12.9417 16.1429 13.1597 16.0525 13.3204 15.8918C13.4812 15.7311 13.5715 15.513 13.5715 15.2857V14.7836L4.64503 5.85714H3.28578ZM1.46751 4.89601C1.94975 4.41377 2.6038 4.14285 3.28578 4.14285H5.00007C5.2274 4.14285 5.44542 4.23316 5.60616 4.3939L15.0347 13.8225C15.1955 13.9832 15.2858 14.2012 15.2858 14.4286V15.2857C15.2858 15.9677 15.0149 16.6217 14.5326 17.104C14.0504 17.5862 13.3963 17.8571 12.7144 17.8571H3.28578C2.6038 17.8571 1.94975 17.5862 1.46751 17.104C0.985273 16.6217 0.714355 15.9677 0.714355 15.2857V6.71428C0.714355 6.0323 0.985273 5.37824 1.46751 4.89601ZM12.7144 5.85714H9.8515C9.37811 5.85714 8.99436 5.47338 8.99436 5C8.99436 4.52661 9.37811 4.14285 9.8515 4.14285H12.7144C13.3963 4.14285 14.0504 4.41377 14.5326 4.89601C15.0149 5.37824 15.2858 6.0323 15.2858 6.71428V9.2221L15.3753 9.31164L19.9263 6.01978C20.1872 5.83106 20.5318 5.80449 20.8186 5.95097C21.1053 6.09746 21.2858 6.39229 21.2858 6.71428V15.2857C21.2858 15.7591 20.902 16.1429 20.4286 16.1429C19.9553 16.1429 19.5715 15.7591 19.5715 15.2857V8.39215L15.7881 11.1288C15.4471 11.3755 14.9773 11.338 14.6797 11.0404L13.8225 10.1832C13.6618 10.0225 13.5715 9.80447 13.5715 9.57714V6.71428C13.5715 6.48695 13.4812 6.26894 13.3204 6.10819C13.1597 5.94744 12.9417 5.85714 12.7144 5.85714Z"
                            fill="white"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M0.965407 0.965331C1.30014 0.630595 1.84285 0.630595 2.17759 0.965331L21.0347 19.8225C21.3695 20.1572 21.3695 20.6999 21.0347 21.0347C20.7 21.3694 20.1573 21.3694 19.8225 21.0347L0.965407 2.17751C0.630672 1.84278 0.630672 1.30007 0.965407 0.965331Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect
                              width="20.5714"
                              height="20.5714"
                              fill="white"
                              transform="translate(0.714355 0.714279)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </button>
                    <button :class="{ active: !muteMic }" @click="toggleAudio">
                      <svg
                        v-if="!muteMic"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.57549 1.71848C9.21848 1.0755 10.0905 0.714279 10.9999 0.714279C11.9092 0.714279 12.7812 1.0755 13.4242 1.71848C14.0672 2.36147 14.4284 3.23354 14.4284 4.14285V11C14.4284 11.9093 14.0672 12.7814 13.4242 13.4244C12.7812 14.0673 11.9092 14.4286 10.9999 14.4286C10.0905 14.4286 9.21848 14.0673 8.57549 13.4244C7.93251 12.7814 7.57129 11.9093 7.57129 11V4.14285C7.57129 3.23354 7.93251 2.36147 8.57549 1.71848ZM10.9999 2.42856C10.5452 2.42856 10.1092 2.60918 9.78768 2.93067C9.46619 3.25216 9.28557 3.68819 9.28557 4.14285V11C9.28557 11.4547 9.46619 11.8907 9.78768 12.2122C10.1092 12.5337 10.5452 12.7143 10.9999 12.7143C11.4545 12.7143 11.8906 12.5337 12.212 12.2122C12.5335 11.8907 12.7141 11.4547 12.7141 11V4.14285C12.7141 3.68819 12.5335 3.25216 12.212 2.93067C11.8906 2.60918 11.4545 2.42856 10.9999 2.42856Z"
                            fill="white"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5.00021 8.42856C5.4736 8.42856 5.85735 8.81231 5.85735 9.2857V11C5.85735 12.364 6.39919 13.6721 7.36366 14.6365C8.32813 15.601 9.63624 16.1428 11.0002 16.1428C12.3642 16.1428 13.6723 15.601 14.6368 14.6365C15.6012 13.6721 16.1431 12.364 16.1431 11V9.2857C16.1431 8.81231 16.5268 8.42856 17.0002 8.42856C17.4736 8.42856 17.8574 8.81231 17.8574 9.2857V11C17.8574 12.8186 17.1349 14.5628 15.8489 15.8487C14.563 17.1347 12.8188 17.8571 11.0002 17.8571C9.18158 17.8571 7.43744 17.1347 6.15148 15.8487C4.86551 14.5628 4.14307 12.8186 4.14307 11V9.2857C4.14307 8.81231 4.52682 8.42856 5.00021 8.42856Z"
                            fill="white"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M11.0002 16.1429C11.4736 16.1429 11.8574 16.5266 11.8574 17V20.4286C11.8574 20.902 11.4736 21.2857 11.0002 21.2857C10.5268 21.2857 10.1431 20.902 10.1431 20.4286V17C10.1431 16.5266 10.5268 16.1429 11.0002 16.1429Z"
                            fill="white"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M6.71436 20.4286C6.71436 19.9552 7.09811 19.5714 7.5715 19.5714H14.4286C14.902 19.5714 15.2858 19.9552 15.2858 20.4286C15.2858 20.902 14.902 21.2857 14.4286 21.2857H7.5715C7.09811 21.2857 6.71436 20.902 6.71436 20.4286Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect
                              width="20.5714"
                              height="20.5714"
                              fill="white"
                              transform="translate(0.714355 0.714279)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <svg
                        v-else
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.57549 1.71848C9.21848 1.0755 10.0905 0.714279 10.9999 0.714279C11.9092 0.714279 12.7812 1.0755 13.4242 1.71848C14.0672 2.36147 14.4284 3.23354 14.4284 4.14285V11C14.4284 11.9093 14.0672 12.7814 13.4242 13.4244C12.7812 14.0673 11.9092 14.4286 10.9999 14.4286C10.0905 14.4286 9.21848 14.0673 8.57549 13.4244C7.93251 12.7814 7.57129 11.9093 7.57129 11V4.14285C7.57129 3.23354 7.93251 2.36147 8.57549 1.71848ZM10.9999 2.42856C10.5452 2.42856 10.1092 2.60918 9.78768 2.93067C9.46619 3.25216 9.28557 3.68819 9.28557 4.14285V11C9.28557 11.4547 9.46619 11.8907 9.78768 12.2122C10.1092 12.5337 10.5452 12.7143 10.9999 12.7143C11.4545 12.7143 11.8906 12.5337 12.212 12.2122C12.5335 11.8907 12.7141 11.4547 12.7141 11V4.14285C12.7141 3.68819 12.5335 3.25216 12.212 2.93067C11.8906 2.60918 11.4545 2.42856 10.9999 2.42856Z"
                            fill="white"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5.00021 8.42856C5.4736 8.42856 5.85735 8.81231 5.85735 9.2857V11C5.85735 12.364 6.39919 13.6721 7.36366 14.6365C8.32813 15.601 9.63624 16.1428 11.0002 16.1428C12.3642 16.1428 13.6723 15.601 14.6368 14.6365C15.6012 13.6721 16.1431 12.364 16.1431 11V9.2857C16.1431 8.81231 16.5268 8.42856 17.0002 8.42856C17.4736 8.42856 17.8574 8.81231 17.8574 9.2857V11C17.8574 12.8186 17.1349 14.5628 15.8489 15.8487C14.563 17.1347 12.8188 17.8571 11.0002 17.8571C9.18158 17.8571 7.43744 17.1347 6.15148 15.8487C4.86551 14.5628 4.14307 12.8186 4.14307 11V9.2857C4.14307 8.81231 4.52682 8.42856 5.00021 8.42856Z"
                            fill="white"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M11.0002 16.1429C11.4736 16.1429 11.8574 16.5266 11.8574 17V20.4286C11.8574 20.902 11.4736 21.2857 11.0002 21.2857C10.5268 21.2857 10.1431 20.902 10.1431 20.4286V17C10.1431 16.5266 10.5268 16.1429 11.0002 16.1429Z"
                            fill="white"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M6.71436 20.4286C6.71436 19.9552 7.09811 19.5714 7.5715 19.5714H14.4286C14.902 19.5714 15.2858 19.9552 15.2858 20.4286C15.2858 20.902 14.902 21.2857 14.4286 21.2857H7.5715C7.09811 21.2857 6.71436 20.902 6.71436 20.4286Z"
                            fill="white"
                          />
                        </g>
                        <line
                          x1="1.14728"
                          y1="3.3406"
                          x2="20.0262"
                          y2="17.0368"
                          stroke="white"
                          stroke-width="2"
                        />
                        <defs>
                          <clipPath id="clip0">
                            <rect
                              width="20.5714"
                              height="20.5714"
                              fill="white"
                              transform="translate(0.714355 0.714279)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </button>
                  </div>
                  <div class="menu-btn" title="Settings">
                    <svg
                      @click="setting = !setting"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z"
                        fill="white"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10 5C10 3.89543 10.8954 3 12 3C13.1046 3 14 3.89543 14 5C14 6.10457 13.1046 7 12 7C10.8954 7 10 6.10457 10 5Z"
                        fill="white"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10 19C10 17.8954 10.8954 17 12 17C13.1046 17 14 17.8954 14 19C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="right-pane mt-5 mt-lg-0">
              <h3>Join with Session Code</h3>
              <span class="bottom-border"></span>
              <div class="input-code">
                <input
                  type="text"
                  v-model="sessionCode"
                  placeholder="Your Session Code"
                />
                <button
                  v-if="!joinWithCode"
                  @click="handleJoinWithCode"
                  class="btn"
                >
                  Join
                </button>
                <button v-else disabled class="btn">
                  Joining
                </button>
              </div>
              <div v-if="sessions.length > 0 || guideSessions.length > 0">
                <h3>Book a Session</h3>
                <span class="bottom-border"></span>
                <div class="session-card-section">
                  <b-tabs content-class="mt-3" justified>
                    <b-tab v-if="sessions.length > 0" title="Sessions" active
                      ><SessionCard
                        v-for="(session, index) in sessions"
                        :session="session"
                        :key="index"
                        @handleSessionClick="handleSessionClick"
                    /></b-tab>
                    <b-tab
                      v-if="guideSessions.length > 0"
                      title="Guide Sessions"
                      ><SessionCard
                        v-for="(session, index) in guideSessions"
                        :session="session"
                        :key="index"
                        @handleSessionClick="handleSessionClick"
                    /></b-tab>
                  </b-tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="showFeedbackPage">
      <session-feedback
        :session="selectedSession"
        :profile="profile ? profile : selectedSession.user"
        @rejoin-session="rejoinSession"
        @submit-feedback="submitFeedback"
        @back-to-lounge="backToLounge"
      />
    </div>
    <div v-if="showGuideHelp">
      <help-chat :guide="guideData" :ip="ip" />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import firebase from "firebase";
import AudioVisual from "vue-audio-visual";
import * as VueWindow from "@hscmap/vue-window";
import s3 from "@/services/amazon-s3";
import VueObserveVisibility from "vue-observe-visibility";
import axios from "axios";
import moment from "moment";

//import HelpChat from "./helpChat";
import SessionCard from "./sessionCard";
import SessionSettings from "./sessionSettings";
import SessionNavbar from "./sessionNavbar";
import SessionRoom from "./sessionRoom";
import SessionFeedback from "./sessionFeedback";

Vue.use(VueObserveVisibility);
Vue.use(VueWindow);
Vue.use(AudioVisual);

export default {
  name: "LiveSession",
  components: {
    // HelpChat,
    SessionNavbar,
    SessionCard,
    SessionRoom,
    SessionSettings,
    SessionFeedback
  },
  data() {
    return {
      fetching: true,
      showGuideHelp: false,
      userExists: false,
      enteredRoom: false,
      peerConnectionState: null,
      dataChannel: null,
      iceConnectionState: null,
      iceGatheringState: null,
      selectedSession: null,
      signalingState: null,
      sessionState: "bookingslounge",
      rating1: 3,
      rating2: 3,
      rating3: 3,
      desc: ["terrible", "bad", "normal", "good", "wonderful"],
      peerConnection: null,
      localStream: null,
      remoteStream: null,
      localVideo: null,
      roomId: null,
      roomRef: null,
      // Media config
      constraints: {
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: false
        },
        video: {
          width: 1280,
          height: 720
        }
      },
      // STUN ice servers
      configuration: {},
      muteMic: true,
      muteCamera: true,
      otherUserMicMuted: false,
      otherUserCameraMuted: false,
      otherUserTime: "",
      sharingScreen: false,
      displayStream: null,
      menuDropdown: false,
      refresh: 1,
      refreshUserMedia: 1,
      localTimeInterval: null,
      micLabel: null,
      cameraLabel: null,
      setting: false,
      recording: false,
      caller: false,
      callee: false,
      localChannel: null,
      remoteChannel: null,
      mediaRecorder: null,
      chats: [],
      recordedBlobs: [],
      sessions: [],
      guideSessions: [],
      showVideo: false,
      showFeedbackPage: false,
      charityVideoURL: "",
      myAudio: null,
      joinWithCode: false,
      sessionCode: "",
      guideData: {},
      ip: ""
    };
  },
  beforeMount() {
    const myBucket = "journeybindersessionvideo";
    const myKey = "charityvideo.mp4";
    s3.getSignedUrl(
      "getObject",
      { Bucket: myBucket, Key: myKey },
      (error, data) => {
        if (error != null) {
          console.log("Failed to retrieve charity video:", error);
        } else {
          this.charityVideoURL = data;
        }
      }
    );

    window.addEventListener(
      "dragover",
      function(e) {
        e = e || event;
        e.preventDefault();
      },
      false
    );

    window.onbeforeunload = function(event) {
      event.preventDefault();
      var message = "Important: Please hangup in order to leave Sessions.";
      if (typeof event == "undefined") {
        event = window.event;
      }
      if (event) {
        event.returnValue = message;
      }
      return message;
    };
  },
  beforeDestroy() {
    if (this.caller || this.callee) {
      this.handleHangUp();
    }
  },
  created() {
    this.openUserMedia();
  },
  mounted() {
    this.getIceServers();
    firebase.auth().onAuthStateChanged(async user => {
      if (user) {
        this.userExists = true;
        await this.$store.commit("user/UPDATE_USER", { user });
        await this.$store.dispatch("user/getProfile");
        await this.setUpLounge();
      } else {
        if (this.$route.query.code) {
          this.sessionCode = this.$route.query.code;
        }
        this.fetching = false;
      }
      if (this.$route.params.guideName && !this.$route.query.code) {
        this.getGuideData();
      }
    });
  },
  computed: {
    ...mapGetters({
      profile: "user/profile"
    })
  },
  methods: {
    getIceServers() {
      axios
        .get(
          `https://us-central1-${process.env.VUE_APP_DB_NAME}.cloudfunctions.net/turn_servers`
        )
        .then(res => {
          this.configuration = res.data.token;
        });
    },
    getGuideData() {
      axios.get("https://api.ipify.org?format=json").then(res => {
        this.ip = res.data.ip;
      });
      this.$store
        .dispatch(
          "listings/getGuideByProfileName",
          this.$route.params.guideName
        )
        .then(res => {
          if (res.user) {
            this.showGuideHelp = true;
            this.guideData = Object.assign({}, res);
          }
        });
    },
    setUpLounge() {
      this.$nprogress.start();
      this.$nprogress.done();

      this.$store
        .dispatch("user/getListSessions")
        .then(data => {
          if (data.length) {
            this.sessions = data;
          }
        })
        .catch(error => {
          this.fetching = false;
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });

      this.$store
        .dispatch("user/getListGuideSessions")
        .then(data => {
          console.log(data);
          if (data.length) {
            this.guideSessions = data;
          }
          if (this.$route.query.code) {
            this.guideSessions.forEach(session => {
              if (session.session_code !== this.$route.query.code) {
                this.sessionCode = this.$route.query.code;
              }
            });
          }
          this.fetching = false;
        })
        .catch(error => {
          this.fetching = false;
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    visibiltyCheck(isVisible, entry) {
      if (isVisible) {
        if (document.querySelector("#localVideo")) {
          document.querySelector("#localVideo").srcObject = this.localStream;
        }
      }
      console.log("Entered", entry);
    },
    async openUserMedia() {
      var self = this;
      var stream = null;
      try {
        stream = await navigator.mediaDevices.getUserMedia(self.constraints);
      } catch (e) {
        var cameras = [];
        navigator.mediaDevices.enumerateDevices().then(devices => {
          devices.forEach(device => {
            if (device.kind == "videoinput") {
              cameras.push(device.deviceId);
            }
          });
        });
        do {
          var index = 1;
          try {
            const constraints = {
              audio: self.constraints.audio,
              video: {
                deviceId: { exact: cameras[index] },
                width: 1280,
                height: 720
              }
            };
            stream = await navigator.mediaDevices.getUserMedia(constraints);
          } catch (e) {
            index++;
          }
        } while (!stream);
      }
      if (stream) {
        self.localStream = stream;
        self.remoteStream = new MediaStream();
        self.muteMic = false;
        self.muteCamera = false;
        self.sharingScreen = false;
        self.renderMeter();

        var tracks = stream.getTracks();
        if (tracks.length > 0) {
          tracks.forEach(track => {
            if (track.kind == "audio") {
              this.micLabel = track.label;
            } else if (track.kind == "video") {
              this.cameraLabel = track.label;
            }
          });
        }
        self.refreshUserMedia++;
        if (document.querySelector("#localVideo")) {
          document.querySelector("#localVideo").srcObject = stream;
        }
      }
    },
    registerPeerConnectionListeners() {
      this.peerConnection.addEventListener("icegatheringstatechange", () => {
        console.log(
          `ICE gathering state changed: ${this.peerConnection.iceGatheringState}`
        );
        this.iceGatheringState = this.peerConnection.iceGatheringState;
      });

      this.peerConnection.addEventListener(
        "connectionstatechange",
        async () => {
          console.log(
            `Connection state change: ${this.peerConnection.connectionState}`
          );
          if (this.peerConnection.connectionState == "disconnected") {
            setTimeout(async () => {
              if (
                this.peerConnection &&
                this.peerConnection.connectionState == "disconnected"
              ) {
                await this.renewConnection();
              }
            }, 5000);
          }
          console.log("Peer connection:", this.peerConnection);
          this.peerConnectionState = this.peerConnection.connectionState;
        }
      );

      this.peerConnection.addEventListener("signalingstatechange", () => {
        //@TODO:On Disconnection make the image the user again.
        // console.log(
        //   `Will show a black screen with the user's image in the center`
        // );
        console.log(
          `Signaling state change: ${this.peerConnection.signalingState}`
        );
        this.signalingState = this.peerConnection.signalingState;
      });

      this.peerConnection.addEventListener("iceconnectionstatechange ", () => {
        console.log(
          `ICE connection state change: ${this.peerConnection.iceConnectionState}`
        );
        this.iceConnectionState = this.peerConnection.iceConnectionState;
      });
    },
    sendMessage(msg) {
      if (!this.remoteChannel) {
        this.localChannel.send(JSON.stringify(msg));
        this.chats.push(msg);
      } else {
        this.remoteChannel.send(JSON.stringify(msg));
        this.chats.push(msg);
      }
    },
    async toggleAudio() {
      // var tracks = this.localStream.getAudioTracks();
      if (this.localStream.getAudioTracks()) {
        this.localStream.getAudioTracks().forEach(track => {
          if (track.label !== "System Audio") {
            track.enabled = !track.enabled;
          }
          if (this.peerConnection) {
            this.peerConnection.getSenders().forEach(sender => {
              if (sender.track.kind == track.kind) {
                sender.replaceTrack(track);
                console.log("Changed sender audio:", sender);
              }
            });
          }
          console.log(this.localStream.getTracks(), "Changed local audio");
        });
        this.muteMic = !this.muteMic;
        if (this.caller) {
          this.roomRef
            .collection("info")
            .doc("caller_stream")
            .update({
              _updated_at: new Date(),
              user: this.profile.firstname || "",
              micMuted: this.muteMic
            });
        } else if (this.callee) {
          this.roomRef
            .collection("info")
            .doc("callee_stream")
            .update({
              _updated_at: new Date(),
              user: this.profile.firstname || "",
              micMuted: this.muteMic
            });
        }
      }
    },
    toggleVideo() {
      if (this.localStream.getVideoTracks()) {
        this.localStream.getVideoTracks().forEach(track => {
          track.enabled = !track.enabled;
          if (this.localpeerConnection) {
            this.localpeerConnection.getSenders().map(sender => {
              if (sender.track.kind == track.kind) {
                sender.replaceTrack(track);
                console.log("Changed sender video:", sender);
              }
            });
          }
        });
        this.muteCamera = !this.muteCamera;
        console.log(this.localStream.getTracks(), "changed local video");
        if (this.caller) {
          this.roomRef
            .collection("info")
            .doc("caller_stream")
            .update({
              _updated_at: new Date(),
              user: this.profile.firstname || "",
              cameraMuted: this.muteCamera
            });
        } else if (this.callee) {
          this.roomRef
            .collection("info")
            .doc("callee_stream")
            .update({
              _updated_at: new Date(),
              user: this.profile.firstname || "",
              cameraMuted: this.muteCamera
            });
        }
      }
    },
    changeAudioInput(audioSource) {
      var self = this;
      const constraints = {
        audio: { deviceId: audioSource ? { exact: audioSource } : undefined },
        video: self.constraints.video
      };
      navigator.mediaDevices.getUserMedia(constraints).then(stream => {
        if (self.peerConnection) {
          self.peerConnection.getSenders().map(sender => {
            stream.getTracks().forEach(track => {
              if (track.kind == "audio") {
                self.micLabel = track.label;
              } else if (track.kind == "video") {
                self.cameraLabel = track.label;
              }
              if (sender.track.kind == track.kind) {
                track.enabled = true;
                sender.replaceTrack(track);
                console.log("Changed sender mic:", sender);
              }
            });
          });
        }
        self.muteMic = false;
        self.muteCamera = false;
        self.localStream = stream;
        self.renderMeter();
        self.refresh++;
        if (document.querySelector("#localVideo")) {
          document.querySelector("#localVideo").srcObject = stream;
        }
      });
    },
    changeVideoInput(videoSource) {
      var self = this;
      const constraints = {
        audio: self.constraints.audio,
        video: { deviceId: videoSource ? { exact: videoSource } : undefined }
      };
      navigator.mediaDevices.getUserMedia(constraints).then(stream => {
        if (self.peerConnection) {
          self.peerConnection.getSenders().map(sender => {
            stream.getTracks().forEach(track => {
              if (track.kind == "audio") {
                self.micLabel = track.label;
              } else if (track.kind == "video") {
                self.cameraLabel = track.label;
              }
              if (sender.track.kind == track.kind) {
                track.enabled = true;
                sender.replaceTrack(track);
                console.log("Changed sender camera:", sender);
              }
            });
          });
        }
        self.refresh++;
        self.muteMic = false;
        self.muteCamera = false;
        self.localStream = stream;
        self.renderMeter();
        if (document.querySelector("#localVideo")) {
          document.querySelector("#localVideo").srcObject = stream;
        }
      });
    },
    changeAudioOutput(outputSource) {
      var video = document.querySelector("#localVideo");
      this.attachSpeakers(video, outputSource);
    },
    attachSpeakers(element, sinkId) {
      if (typeof element.sinkId !== "undefined") {
        element
          .setSinkId(sinkId)
          .then(() => {
            console.log(`Success, audio output device attached: ${sinkId}`);
          })
          .catch(error => {
            let errorMessage = error;
            if (error.name === "SecurityError") {
              errorMessage = `You need to use HTTPS for selecting audio output device: ${error}`;
            }
            console.error(errorMessage);
          });
      } else {
        console.warn("Browser does not support output device selection.");
      }
    },
    handleJoinWithCode() {
      let allSessions = [];
      this.joinWithCode = true;
      const db = firebase.firestore();
      db.collection("sessions")
        .get()
        .then(sessions => {
          sessions.forEach(doc => {
            allSessions.push({ id: doc.id, ...doc.data() });
          });
          for (let index = 0; index < allSessions.length; index++) {
            if (
              allSessions[index].session_code == this.sessionCode &&
              allSessions[index].guide.profileName ==
                this.$route.params.guideName
            ) {
              this.handleSessionClick(allSessions[index]);
              this.joinWithCode = false;
            }
            //   else if (
            //   index == allSessions.length - 1 &&
            //   allSessions[index].session_code !== this.sessionCode
            // ) {
            //   this.joinWithCode = false;
            //   alert("No Session Found.");
            // }
          }
        });
    },
    async handleSessionClick(session) {
      var self = this;
      if (!self.localStream || !self.remoteStream) {
        self.$store.dispatch("user/showNotification", {
          title: "Please turn on your Camera",
          description:
            "Your camera is off- please turn it on by clicking the cam button",
          variant: "warning"
        });
        self.openUserMedia();
        return true;
      }
      try {
        // this.showVideo = true;
        self.enteredRoom = true;
        if (this.myAudio) {
          this.myAudio.close();
        }
        self.selectedSession = session;
        self.roomId = session ? session.room_id : null;

        const db = firebase.firestore();
        self.roomRef = await db
          .collection("sessions_rooms")
          .doc(self.roomId)
          .collection("sessions")
          .doc("cam");
        console.log(self.roomRef);
        const previousCaller = await self.roomRef
          .collection("info")
          .doc("caller_localtime")
          .get();
        let joinRoom = true;
        if (previousCaller.exists) {
          const callerInfo = await previousCaller.data();
          if (callerInfo && callerInfo.utcTime) {
            const startTime = moment.utc(
              callerInfo.utcTime,
              "YYYY-MM-DDTHH:mm:ssZ"
            );
            const currentTime = moment().utc();
            const result = moment.duration(currentTime.diff(startTime));
            const seconds = result.seconds();
            if (seconds > 8) {
              const caller = await self.roomRef
                .collection("caller_candidates")
                .get();
              if (caller) {
                caller.forEach(async candidate => {
                  await candidate.ref.delete();
                });
                console.log("cleared previous");
              }
              joinRoom = false;
            }
          }
        } else {
          joinRoom = false;
        }
        console.log("cleared previous 1");
        // const callerSnapshot = await self.roomRef.get();
        // setTimeout(() => {
        //   let video = document.getElementById("charity-video");
        //   video.play();
        //   video.onended = () => {
        //     this.showVideo = false;
        //   };
        // }, 1000);
        if (joinRoom) {
          console.log("Join room.");
          self.joinRoom();
        } else {
          console.log("Create room.");
          self.createRoom();
        }
      } catch (error) {
        self.enteredRoom = false;
        console.log("Error:", error);
      }
    },
    async createRoom() {
      var self = this;
      console.log("Creating Room.");
      self.caller = true;

      // Creating Peer connection
      self.peerConnection = await new RTCPeerConnection(self.configuration);
      self.registerPeerConnectionListeners();
      self.localStream.getTracks().forEach(track => {
        self.peerConnection.addTrack(track, self.localStream);
      });
      console.log("Created Peer Conenction ");

      // Storing ice candidates for first user
      const userId = self.roomRef.collection("caller_candidates");
      self.peerConnection.addEventListener("icecandidate", event => {
        if (!event.candidate) {
          console.log(
            "Receieved all caller's ICE candidates and gethering stage is completed."
          );
          return;
        }
        console.log("Got caller's ICE candidates");
        userId.add(event.candidate.toJSON());
      });

      const streamInfo = {
        _created_at: new Date(),
        _updated_at: new Date(),
        user: self.profile.firstname || "",
        micMuted: self.muteMic,
        cameraMuted: self.muteCamera
      };
      self.roomRef
        .collection("info")
        .doc("caller_stream")
        .set(streamInfo);

      self.updateLocalTime();

      self.localTimeInterval = setInterval(() => self.updateLocalTime(), 4000);

      self.localChannel = await self.peerConnection.createDataChannel(
        "messaging-channel",
        { ordered: true }
      );
      self.localChannel.binaryType = "arraybuffer";
      self.localChannel.addEventListener("open", () => {
        console.log("Local channel open!");
      });
      self.localChannel.addEventListener("close", () => {
        console.log("Local channel closed!");
      });
      self.localChannel.addEventListener("message", event => {
        let new_msg = JSON.parse(event.data);
        console.log(`Message received by Caller: ${new_msg.text}`);
        new_msg.type = 0;
        self.chats.push(new_msg);
      });

      // Adding tracks to remote stream
      self.peerConnection.addEventListener("track", event => {
        event.streams[0].getTracks().forEach(track => {
          if (!self.remoteStream) {
            self.remoteStream = new MediaStream();
          }
          self.remoteStream.addTrack(track);
        });
      });

      // Creating a room
      self.peerConnection
        .createOffer()
        .then(offer => {
          const roomWithOffer = {
            _created_at: new Date(),
            _created_by:
              this.profile.firstname || this.selectedSession.user.firstname,
            offer: {
              type: offer.type,
              sdp: offer.sdp
            }
          };
          self.roomRef.set(roomWithOffer);
          console.log(`New room created with SDP offer. You are Caller.`);
          return self.peerConnection.setLocalDescription(offer);
        })
        .catch(error => {
          console.log("Error in creating offer:", error);
        });

      // Setting remote description for other user
      self.roomRef.onSnapshot(snapshot => {
        const data = snapshot.data();
        if (self.peerConnection) {
          if (
            !self.peerConnection.currentRemoteDescription &&
            data &&
            data.answer
          ) {
            const rtcSessionDescription = new RTCSessionDescription(
              data.answer
            );
            self.peerConnection
              .setRemoteDescription(rtcSessionDescription)
              .then(() => {})
              .catch(error =>
                console.log("Error in Setting Remote Description:", error)
              );
          }
        }
      });

      // Collecting callee's ICE candidates
      self.roomRef.collection("callee_candidates").onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if (change.type === "added") {
            let data = change.doc.data();
            if (self.peerConnection) {
              self.peerConnection
                .addIceCandidate(new RTCIceCandidate(data))
                .then()
                .catch(error =>
                  console.log(
                    "Error in adding callee's Ice candidates to peerconnection",
                    error
                  )
                );
            }
          }
        });
      });

      self.roomRef.collection("info").onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if (change.doc.id == "callee_stream") {
            this.otherUserMicMuted = change.doc.data().micMuted;
            this.otherUserCameraMuted = change.doc.data().cameraMuted;
          } else if (change.doc.id == "callee_localtime") {
            this.otherUserTime = change.doc.data().localTime;
          }
        });
      });
    },
    async joinRoom() {
      var self = this;
      console.log("Joining Room.");
      self.callee = true;
      self.peerConnection = await new RTCPeerConnection(self.configuration);
      console.log("Created Other user PeerConnection with configuration");
      self.registerPeerConnectionListeners();
      self.localStream.getTracks().forEach(track => {
        self.peerConnection.addTrack(track, self.localStream);
      });

      // Collecting other user ice candidates
      const otherUserId = self.roomRef.collection("callee_candidates");
      self.peerConnection.addEventListener("icecandidate", event => {
        if (!event.candidate) {
          console.log(
            "Receieved all callee's ICE candidates and gethering stage is completed."
          );
          return;
        }
        console.log("Got callee's ICE candidates");
        otherUserId.add(event.candidate.toJSON());
      });

      const streamInfo = {
        _created_at: new Date(),
        _updated_at: new Date(),
        user: self.profile.firstname || "",
        micMuted: self.muteMic,
        cameraMuted: self.muteCamera
      };
      self.roomRef
        .collection("info")
        .doc("callee_stream")
        .set(streamInfo);
      self.updateLocalTime();

      self.localTimeInterval = setInterval(() => self.updateLocalTime(), 4000);

      self.peerConnection.addEventListener("datachannel", event => {
        console.log(`onRemoteDataChannel: ${JSON.stringify(event)}`);
        self.remoteChannel = event.channel;
        self.remoteChannel.binaryType = "arraybuffer";
        self.remoteChannel.addEventListener("message", event => {
          let new_msg = JSON.parse(event.data);
          console.log(`Message received by Callee: ${new_msg.text}`);
          new_msg.type = 0;
          self.chats.push(new_msg);
        });
        self.remoteChannel.addEventListener("open", () => {
          console.log("Remote channel open!");
        });
        self.remoteChannel.addEventListener("close", () => {
          console.log("Remote channel closed!");
        });
      });

      // Adding tracks to remote stream
      self.peerConnection.addEventListener("track", event => {
        event.streams[0].getTracks().forEach(track => {
          self.remoteStream.addTrack(track);
        });
      });

      // Creating Answer and setting local description
      self.roomRef.get().then(snap => {
        if (snap.data().offer) {
          console.log("Got offer");
          self.peerConnection.setRemoteDescription(
            new RTCSessionDescription(snap.data().offer)
          );
          self.peerConnection
            .createAnswer()
            .then(async answer => {
              console.log("Created answer", answer);
              const roomWithAnswer = {
                answer: {
                  type: answer.type,
                  sdp: answer.sdp
                }
              };
              await self.roomRef.update(roomWithAnswer);

              self.peerConnection
                .setLocalDescription(answer)
                .then(() => {
                  //  Collecting caller's ICE candidates below
                  self.roomRef
                    .collection("caller_candidates")
                    .onSnapshot(snapshot => {
                      snapshot.docChanges().forEach(change => {
                        if (change.type === "added") {
                          let data = change.doc.data();
                          if (self.peerConnection) {
                            console.log(
                              `Add caller's ICE candidates to peerconnection`
                            );
                            self.peerConnection
                              .addIceCandidate(new RTCIceCandidate(data))
                              .then()
                              .catch(error =>
                                console.log(
                                  "Error in adding caller's ICE candidates to peerconnection",
                                  error
                                )
                              );
                          }
                        }
                      });
                    });
                  self.roomRef.collection("info").onSnapshot(snapshot => {
                    snapshot.docChanges().forEach(change => {
                      if (change.doc.id == "caller_stream") {
                        this.otherUserMicMuted = change.doc.data().micMuted;
                        this.otherUserCameraMuted = change.doc.data().cameraMuted;
                      } else if (change.doc.id == "caller_localtime") {
                        this.otherUserTime = change.doc.data().localTime;
                      }
                    });
                  });
                })
                .catch(e => {
                  console.log(
                    "Error in setting local description for other user",
                    e
                  );
                });
            })
            .catch(e => {
              console.log("Error in creating answer", e);
            });
        }
      });
    },
    updateLocalTime() {
      let time = moment(new Date()).format("hh:mm A");
      let utcTime = moment()
        .utc()
        .format("YYYY-MM-DDTHH:mm:ssZ");
      let timeInfo = {
        _updated_at: new Date(),
        user: this.profile.firstname || this.selectedSession.user.firstname,
        localTime: time,
        utcTime: utcTime
      };
      if (this.caller) {
        this.roomRef
          .collection("info")
          .doc("caller_localtime")
          .set(timeInfo);
      } else {
        this.roomRef
          .collection("info")
          .doc("callee_localtime")
          .set(timeInfo);
      }
    },
    async shareScreen() {
      var stream;
      if (!this.sharingScreen) {
        if (navigator.getDisplayMedia) {
          stream = await navigator.getDisplayMedia({ video: true });
        } else if (navigator.mediaDevices.getDisplayMedia) {
          stream = await navigator.mediaDevices.getDisplayMedia({
            video: true
          });
        } else {
          stream = await navigator.mediaDevices.getUserMedia({
            video: { mediaSource: "screen" }
          });
        }
        this.displayStream = stream;
        var screen = stream.getVideoTracks()[0];
        if (this.peerConnection) {
          // this.peerConnection.addTrack(screen);
          this.peerConnection.getSenders().forEach(sender => {
            if (sender.track.kind == "video") {
              sender.replaceTrack(screen);
            } else {
              this.peerConnection.addTrack(screen);
              // sender.addTrack(screen);
            }
            console.log("Changed sender video:", sender);
          });
        }
        this.sharingScreen = true;
        screen.addEventListener("ended", this.stopSharingScreen);
        // this.refresh++
      } else {
        this.displayStream.getTracks().forEach(track => track.stop());
        this.stopSharingScreen();
        // this.refresh++
      }
    },
    stopSharingScreen() {
      this.sharingScreen = false;
      if (this.peerConnection) {
        // this.peerConnection.removeTrack(this.displayStream.getVideoTracks()[0]);
        // this.refresh++
        this.peerConnection.getSenders().forEach(sender => {
          if (sender.track.kind == "video") {
            if (this.localStream.getVideoTracks()[0]) {
              let track = this.localStream.getVideoTracks()[0];
              sender.replaceTrack(track);
            } else {
              sender.removeTrack(screen);
            }
          }
        });
      }
    },
    renderMeter() {
      var max_level_L = 0;
      var old_level_L = 0;
      // var cnvs = document.getElementById("meter");
      // var cnvs_cntxt = cnvs.getContext("2d");
      // cnvs_cntxt.clearRect(0, 0, cnvs.width, cnvs.height);
      this.myAudio = new AudioContext();
      var microphone = this.myAudio.createMediaStreamSource(this.localStream);
      var javascriptNode = this.myAudio.createScriptProcessor(1024, 1, 1);
      microphone.connect(javascriptNode);
      javascriptNode.connect(this.myAudio.destination);
      javascriptNode.onaudioprocess = function(event) {
        var inpt_L = event.inputBuffer.getChannelData(0);
        var instant_L = 0.0;

        var sum_L = 0.0;
        for (var i = 0; i < inpt_L.length; ++i) {
          sum_L += inpt_L[i] * inpt_L[i];
        }
        instant_L = Math.sqrt(sum_L / inpt_L.length);
        max_level_L = Math.max(max_level_L, instant_L);
        instant_L = Math.max(instant_L, old_level_L - 0.008);
        old_level_L = instant_L;
        let percentage = (instant_L / max_level_L) * 100;
        if (percentage == 0) {
          if (document.getElementById("level1")) {
            document.getElementById("level1").style.fill = "none";
          }
          if (document.getElementById("level2")) {
            document.getElementById("level2").style.fill = "none";
          }
          if (document.getElementById("level3")) {
            document.getElementById("level3").style.fill = "none";
          }
        } else if (percentage > 0 && percentage < 30) {
          if (document.getElementById("level1")) {
            document.getElementById("level1").style.fill = "var(--theme-color)";
          }
          if (document.getElementById("level2")) {
            document.getElementById("level2").style.fill = "none";
          }
          if (document.getElementById("level3")) {
            document.getElementById("level3").style.fill = "none";
          }
        } else if (percentage > 30 && percentage < 60) {
          if (document.getElementById("level1")) {
            document.getElementById("level1").style.fill = "var(--theme-color)";
          }
          if (document.getElementById("level2")) {
            document.getElementById("level2").style.fill = "var(--theme-color)";
          }
          if (document.getElementById("level3")) {
            document.getElementById("level3").style.fill = "none";
          }
        } else if (percentage > 60) {
          if (document.getElementById("level1")) {
            document.getElementById("level1").style.fill = "var(--theme-color)";
          }
          if (document.getElementById("level2")) {
            document.getElementById("level2").style.fill = "var(--theme-color)";
          }
          if (document.getElementById("level3")) {
            document.getElementById("level3").style.fill = "var(--theme-color)";
          }
        }
        // cnvs_cntxt.clearRect(0, 0, cnvs.width, cnvs.height);
        // cnvs_cntxt.fillStyle = "#00ff00";
        // cnvs_cntxt.fillRect(
        //   10,
        //   10,
        //   (cnvs.width - 20) * (instant_L / max_level_L),
        //   cnvs.height - 20
        // ); // x,y,w,h
        // if ((instant_L / max_level_L) * 100 > 40) {
        //   console.log("hiii");
        // }
      };
    },
    handlePhoneToggleClick() {
      if (this.localStream && this.remoteStream) {
        this.handleHangUp();
      } else {
        this.openUserMedia();
      }
    },
    async renewConnection() {
      var self = this;
      if (document.querySelector("#localVideo")) {
        const tracks = document
          .querySelector("#localVideo")
          .srcObject.getTracks();
        tracks.forEach(track => {
          track.stop();
        });
      }

      if (self.remoteStream) {
        self.remoteStream.getTracks().forEach(track => track.stop());
        self.remoteStream = null;
      }

      if (self.peerConnection) {
        self.peerConnection.close();
      }

      if (self.roomId) {
        const caller = await self.roomRef.collection("caller_candidates").get();
        if (caller) {
          caller.forEach(async candidate => {
            await candidate.ref.delete();
          });
        }

        const callee = await self.roomRef.collection("callee_candidates").get();
        if (callee) {
          callee.forEach(async candidate => {
            await candidate.ref.delete();
          });
        }

        await self.roomRef.delete();
        self.roomRef = null;
        const db = firebase.firestore();
        self.roomRef = await db
          .collection("sessions_rooms")
          .doc(self.roomId)
          .collection("sessions")
          .doc("cam");

        self.peerConnection = null;
        self.localChannel = null;
        self.remoteChannel = null;
        self.caller = false;
        self.callee = false;

        self.createRoom();
      }
    },
    rejoinSession(session) {
      this.showFeedbackPage = false;
      // this.openUserMedia();
      this.handleSessionClick(session);
    },
    backToLounge() {
      this.showFeedbackPage = false;
    },
    async submitFeedback(feedback, id) {
      const db = firebase.firestore();
      let docRef = await db
        .collection("sessions_rooms")
        .doc(id)
        .collection("logs")
        .doc();
      docRef.set(feedback);
    },
    async handleHangUp() {
      var self = this;
      this.enteredRoom = false;
      this.showFeedbackPage = true;
      if (self.localStream) {
        self.localStream.getTracks().forEach(track => track.stop());
        self.localStream = null;
      }
      if (self.remoteStream) {
        self.remoteStream.getTracks().forEach(track => track.stop());
        self.remoteStream = null;
      }
      if (self.peerConnection) {
        self.peerConnection.close();
      }
      this.openUserMedia();
      clearInterval(this.localTimeInterval);
      this.localTimeInterval = null;
      if (self.caller) {
        console.log("Caller:", self.caller);
        const user = await self.roomRef.collection("caller_candidates").get();
        user.forEach(async candidate => {
          await candidate.ref.delete();
        });
        await self.roomRef
          .collection("info")
          .doc("caller_stream")
          .delete();
        await self.roomRef
          .collection("info")
          .doc("caller_localtime")
          .delete();
        self.caller = false;
        self.localChannel = null;
      } else if (self.callee) {
        console.log("Callee:", self.callee);
        const user = await self.roomRef.collection("callee_candidates").get();
        user.forEach(async candidate => {
          await candidate.ref.delete();
        });
        await self.roomRef
          .collection("info")
          .doc("callee_stream")
          .delete();
        await self.roomRef
          .collection("info")
          .doc("callee_localtime")
          .delete();

        self.callee = false;
        self.remoteChannel = null;
      }

      const caller = await self.roomRef.collection("caller_candidates").get();
      const callee = await self.roomRef.collection("callee_candidates").get();
      console.log(
        "Room empty?",
        "Caller:",
        caller.empty,
        "Callee:",
        callee.empty
      );
      if (caller.empty && callee.empty) {
        await self.roomRef.delete();
        self.roomRef = null;
      } else {
        self.roomRef = null;
      }

      self.roomRef = null;
      self.roomId = null;
      self.peerConnection = null;
    },
    deleteNote(e) {
      this.notes.splice(e.ni, 1);
    },
    modalValue(e) {
      this.currentNote = e.ni;
      this.note = this.notes[e.ni].note;
    },
    saveNote() {
      if (this.newNote) {
        this.notes.push({ note: this.note, color: 1 });
        this.newNote = false;
        return;
      } else {
        this.notes[this.currentNote].note = this.note;
      }
      this.note = "";
    },
    changeColor(e) {
      this.notes[e.ni].color = e.ci;
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  background: #f3f6f9;
  width: calc(100vw);
  min-height: 100vh;
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    background: transparent;
  }
  .left-pane {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    .display-pane {
      width: 100%;
      height: 40vh;
      min-height: 300px;
      background: #b3c2cb;
      border-radius: 16px;
      position: relative;
      margin-top: -50px;
      .local-video {
        width: 100%;
        height: 101%;
        border-radius: 16px;
      }
      .settings {
        position: absolute;
        top: 10%;
        width: 90%;
        left: 5%;
        z-index: 4;
      }
      .display-actions {
        z-index: 2;
        position: absolute;
        bottom: 10px;
        left: 5%;
        width: 90%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .menu-btn {
          cursor: pointer;
        }
        .action-btn {
          display: flex;
          align-items: center;
          button {
            height: 48px;
            width: 48px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #ef5c4a;
            border: 1px solid #ef5c4a;
            margin: 0 5px;
            transition: all 0.2s ease-in-out;
            &.active {
              background-color: var(--theme-color);
              border: 1px solid var(--theme-color);
            }
            &:hover {
              box-shadow: 0px 0px 4px 0px #333;
            }
          }
        }
      }
    }
  }
  .right-pane {
    h3 {
      margin: 0;
      margin-bottom: 10px;
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 27px;
      color: #474d52;
      position: relative;
      display: inline-block;
      font-family: "Nunito", sans-serif;
      background-color: #f3f6f9;
      padding-right: 19px;
    }
    .bottom-border {
      margin-top: -13px;
      width: 100%;
      border-top: 1px solid #b3c2cb;
      display: block;
    }
    .input-code {
      padding: 16px 0 32px 0;
      input {
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #fff;
        width: 207px;
        height: 48px;
        color: #474d52;
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 25px;
        padding: 16px;
      }
      button {
        margin-left: 10px;
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: 800;
        font-size: 20px;
        line-height: 27px;
        letter-spacing: 0.05em;
        color: #b3c2cb;
        background: none;
        border: none;
        text-transform: uppercase;
        &:hover {
          background: #eee;
        }
      }
    }
    .session-card-section {
      padding: 16px 0;
      .nav-tabs {
        border-radius: 8px;
        .nav-link.active {
          color: #557efb;
        }
      }
    }
  }
}
@media (min-width: 992px) {
  .left-pane {
    margin-left: -35px;
  }
  .right-pane {
    margin-right: -35px;
    margin-left: 35px;
  }
}
// .video-container {
//   width: 622px;
//   height: 355px;
//   border-radius: 10px;
//   background: rgba(0, 0, 0, 0.87);
//   overflow: hidden;
//   margin-bottom: 15px;
// }
// .local-video {
//   width: 630px;
//   height: 355px;
//   z-index: 2;
//   border-radius: 5px;
//   background-color: #0d0d21;
// }
// .no-camera {
//   background: rgba(0, 0, 0, 0.87);
// }
// .player-buttons {
//   position: absolute;
//   display: flex;
//   // justify-content: space-between;
//   top: 290px;
//   left: 257px;
// }
// .player-button {
//   margin-left: 20px;
//   width: 55px;
//   height: 55px;
//   border-radius: 50%;
//   background: transparent !important;
//   background-color: transparent !important;
// }
// .muted {
//   background-color: red !important;
// }
// .sessions-list {
//   max-height: 400px;
//   overflow-y: scroll;
// }

// #sessions-list::-webkit-scrollbar-track {
//   -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
//   border-radius: 10px;
//   background-color: #f5f5f5;
// }

// #sessions-list::-webkit-scrollbar {
//   width: 12px;
//   background-color: #f5f5f5;
// }

// #sessions-list::-webkit-scrollbar-thumb {
//   border-radius: 10px;
//   -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
//   background-color: #555;
// }

// .dropdown-content {
//   /* visibility: hidden; */
//   position: absolute;
//   margin-left: 30px;
//   margin-top: -235px;
//   background-color: #fff;
//   width: 192px;
//   box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
//   border-radius: 8px;
//   z-index: 900;
//   padding: 8px 10px;
// }
// .dropdown-content a {
//   color: black;
//   padding: 12px 16px;
//   text-decoration: none;
//   display: block;
// }
// .dropdown-content a:hover {
//   background-color: #ddd;
// }
// .menu-icon {
//   position: absolute;
//   left: 296px;
// }
// .menu-item {
//   display: flex;
//   justify-content: space-between;
//   padding: 13px 15px;
// }
// #meter {
//   position: absolute;
//   bottom: 55px;
//   left: 25px;
// }
</style>

<style>
.session-card-section .nav-tabs {
  box-shadow: none;
  border-radius: 15px;
}
.session-card-section .nav-tabs .nav-link.active {
  color: var(--theme-color);
}

.charity-video {
  text-align: center;
  margin-top: 50px;
}
</style>
